import { Accordion } from "../components/accordion";
import { Slider } from "../components/sliders";
import { FloatLabel } from "../components/FloatLabel";

document.addEventListener("DOMContentLoaded", (e) => {
	Accordion.init();
	FloatLabel.init();

	const slider = document.querySelector(".slider");
	if (slider) {
		let swiper = slider.querySelector(".swiper");
		Slider.initSwiper(swiper, {
			slidesPerView: 3,
			spaceBetween: 20,
		});
	}
});
